import { useSelector } from 'react-redux';
import {removeItems} from '../../redux/CartReducer';
import { useDispatch } from 'react-redux';
import Header from '../header/Header';
import './Cart.scss';
import './ResponsiveCart.scss';
import {useNavigate} from 'react-router-dom';

const Cart = () => {
    let navigate = useNavigate();
    let dispatch = useDispatch();
    let listOfResults = useSelector(state => state.cart.listOfProducts);

    let removeItem=(id)=>{
        dispatch(removeItems(id));
    }

    let checkout=()=>{
        navigate("/checkout")
    }

    return (
        <div id="home_background">
            <Header />
            <div className="cartList_flex">

                {listOfResults.length > 0 ?
                    <>
                        <div className="cartList_div1">
                            <div className="cartList_heading">
                                <span>Shopping Cart</span>
                                <span>Price</span>
                            </div>

                            {listOfResults.map((data, i) => (
                                <>
                                    <hr />
                                    <div className="cartList_div1_inner" key={data?.sectionImage?.id}>
                                        <img className="cartList_div1_inner1" src={data?.defaultImage} alt={data?.sectionImage?.name} />
                                        <div className="cartList_div1_inner2">
                                            <span>{data?.sectionImage?.about.desc.substring(0, 120)}..</span>
                                            <span><b>{data?.sectionImage?.name}</b></span>
                                            <div>
                                                <span style={{ color: 'green' }}>In Stock</span>
                                                <br />
                                                <span style={{ color: 'grey' }}><b></b>Eligible for FREE Shipping</span>
                                            </div>
                                            <div>
                                            <button className="cartList_div1_button" onClick={()=>{removeItem(i)}}>Remove Item</button>
                                            </div>
                                        </div>
                                        <span className="cartList_div1_inner3">&#8377; {data?.sectionImage?.about?.originalprice}</span>
                                    </div>
                                </>
                            ))}
                            <hr />
                        </div>
                    </> :
                    <>
                        <div className="cartList_div1">
                            <div className="cartList_heading">
                                <span>Your Shopping Cart is empty</span>
                                <span>Price</span>
                            </div>
                            <hr />
                            <div className="cartList_div1_inner">
                                <div className="cartList_div1_inner2">
                                    <span><b>No Items</b></span>

                                </div>
                            </div>
                            <hr />
                        </div>
                    </>}

                <div className="cartList_div2">
                    <h3 style={{ marginTop: '0.5rem' }}>Bill Details</h3>
                    <div className="cartList_div2_outer">
                            {listOfResults.map((data) => (
                                <div className="cartList_div2_inner">
                                    <span>{data?.sectionImage?.name}</span>
                                    <span>&#8377;{data?.sectionImage?.about?.originalprice}</span>
                                </div>
                            ))}
                    </div>
                    <hr style={{ marginTop: '2rem', marginBottom: '2rem' }} />
                    <div className="cartList_div2_outer2">
                        <span><b>Subtotal</b></span>
                        <span style={{marginLeft:'1rem'}}><b>
                        &#8377;{listOfResults.reduce((acc, data) => {
                                return acc + parseInt(data?.sectionImage?.about?.originalprice)
                            }, 0)}
                        </b></span>
                    </div>
                    <br/>
                    {listOfResults.length > 0 ?<>
                    <p className="hyperlink">Your order is eligible for FREE Delivery.</p>
                    <button className="cartList_div2_button" onClick={checkout}>Proceed to Pay</button>
                    </>:null}
                </div>
            </div>
        </div>
    )
}

export default Cart;